import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Features from '../components/Features';
import Expect from '../components/Expect';
import About from '../components/About';
import NatureBanner from '../components/NatureBanner';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <main className="min-h-screen bg-[#f8f3e6] text-[#2c3f25]">
      <Navbar />
      <Hero />
      <Features />
      <About />
      <NatureBanner />
      <Expect />
      <Testimonials />
      <FAQ />
      <Contact />
      <Footer />
    </main>
  );
};

export default Home;
